<template>
  <section class="login-wrapper">
		<div class="container-fluid">
			<b-row>
				<b-col xl="4" lg="4" md="12" class="fxt-bg-img fxt-bg-img2">
					<a href="javascript:void(0);" class="fxt-logo mt-8 d-block">
            <svg width="106px" height="24px" viewBox="0 0 106 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>0DDEA7CC-09FA-43D7-91E5-0FB6CE4E5E4E</title><g id="calendar-9Dec2020" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Header/header" transform="translate(-25.000000, -23.000000)" fill="#FFFFFF"><path d="M37.2171088,23 C40.6784385,23 43.5744946,24.1647612 45.9047399,26.4922442 C48.1732115,28.7147603 49.3481642,31.4316658 49.4297823,34.6412076 C49.4346831,34.8394428 49.2718155,35.0020449 49.0733162,35.0020449 L49.0733162,35.0020449 L43.9787986,35.0020449 C43.7939074,35.0020449 43.6317561,34.8510342 43.6242,34.6665013 C43.5543331,32.9586238 42.9458358,31.4993541 41.7983858,30.2895509 C40.5769865,28.9791096 39.049727,28.323084 37.2171088,28.323084 C35.3844905,28.323084 33.8572311,28.9791096 32.6358318,30.2895509 C31.4138953,31.5778468 30.8032135,33.149024 30.8032135,35.0020449 C30.8032135,36.8560677 31.4138953,38.4382996 32.6358318,39.7488125 C33.7821358,40.9579001 35.1978804,41.5998658 36.8825642,41.6742084 C37.0665959,41.6822938 37.2171088,41.8443236 37.2171088,42.0282841 L37.2171088,42.0282841 L37.2171088,46.643825 C37.2171088,46.8419528 37.0543845,47.0045192 36.8561,47 C33.5312811,46.9226278 30.7444838,45.7713542 28.4951351,43.5461191 C26.1648899,41.2181352 25,38.3702536 25,35.0020449 C25,31.6348381 26.1648899,28.7975819 28.4951351,26.4922442 C30.8254162,24.1647612 33.7325736,23 37.2171088,23 Z M65.6810811,23.3393359 C65.8110743,23.3393359 65.9582568,23.4371834 66.00875,23.5567828 L66.00875,23.5567828 L75.4832162,46.0364191 C75.5974527,46.3076731 75.4499122,46.5296278 75.1551892,46.5296278 L75.1551892,46.5296278 L69.82475,46.5296278 C69.6915338,46.5296278 69.5425608,46.4282385 69.4938581,46.304346 L69.4938581,46.304346 L68.0213176,42.5628857 L58.2475088,42.5628857 L56.80795,46.3018416 C56.7597128,46.4271294 56.6103459,46.5296278 56.4760196,46.5296278 L56.4760196,46.5296278 L51.1480514,46.5296278 C50.8530777,46.5296278 50.7056446,46.30753 50.8204541,46.0360255 L50.8204541,46.0360255 L60.3275081,23.5563535 C60.3780014,23.4370046 60.5254345,23.3393359 60.6551412,23.3393359 L60.6551412,23.3393359 Z M87.1478716,23.474963 C90.1796149,23.474963 92.5549459,24.2323064 94.2749392,25.7465281 C96.0393378,27.2612148 96.9217162,29.3179089 96.9217162,31.9172185 C96.9217162,34.6072561 96.0056757,36.7431584 94.1732365,38.3248895 C92.3404392,39.8844395 89.8512297,40.663964 86.7066824,40.663964 L86.7066824,40.663964 L83.5846959,40.663964 L83.5846959,46.1743 C83.5846959,46.3697446 83.4246216,46.5296278 83.2290946,46.5296278 L83.2290946,46.5296278 L78.2048378,46.5296278 C78.0089527,46.5296278 77.8492365,46.3697446 77.8492365,46.1743 L77.8492365,46.1743 L77.8492365,23.8302908 C77.8492365,23.6348819 78.0089527,23.474963 78.2048378,23.474963 L78.2048378,23.474963 Z M105.023196,23.474963 C105.218723,23.474963 105.378797,23.6348819 105.378797,23.8302908 L105.378797,23.8302908 L105.378797,46.1743 C105.378797,46.3697446 105.218723,46.5296278 105.023196,46.5296278 L105.023196,46.5296278 L99.9989392,46.5296278 C99.8030541,46.5296278 99.6433378,46.3697446 99.6433378,46.1743 L99.6433378,46.1743 L99.6433378,23.8302908 C99.6433378,23.6348819 99.8030541,23.474963 99.9989392,23.474963 L99.9989392,23.474963 Z M114.003473,23.474963 C114.093716,23.474963 114.215115,23.5308452 114.273845,23.5991774 L114.273845,23.5991774 L125.298561,36.4602413 L125.298561,23.8302908 C125.298561,23.6348819 125.458635,23.474963 125.65452,23.474963 L125.65452,23.474963 L130.644399,23.474963 C130.839926,23.474963 131,23.6348819 131,23.8302908 L131,23.8302908 L131,46.1743 C131,46.3697446 130.839926,46.5296278 130.644399,46.5296278 L130.644399,46.5296278 L126.749973,46.5296278 C126.660804,46.5296278 126.54048,46.4749262 126.482108,46.4081323 L126.482108,46.4081323 L115.525074,33.8831845 L115.525074,46.1743 C115.525074,46.3697446 115.365,46.5296278 115.169473,46.5296278 L115.169473,46.5296278 L110.144858,46.5296278 C109.949331,46.5296278 109.789257,46.3697446 109.789257,46.1743 L109.789257,46.1743 L109.789257,23.8302908 C109.789257,23.6348819 109.949331,23.474963 110.144858,23.474963 L110.144858,23.474963 Z M40.9961878,37.3183301 C41.0893676,37.2235593 41.2658074,37.1883557 41.3882804,37.2400521 L41.3882804,37.2400521 L47.9629304,40.0156303 C48.1582784,40.0980941 48.2363101,40.3184031 48.1404804,40.5073722 C47.5850905,41.6023701 46.8356419,42.6135446 45.8997622,43.5484804 C44.9502385,44.4876735 43.8896297,45.2389349 42.7488764,45.7945013 C42.5615142,45.8857303 42.3433547,45.8075596 42.2616345,45.615943 L42.2616345,45.615943 L39.5021966,39.1514596 C39.4506291,39.0310374 39.4836108,38.8560925 39.5755014,38.7626812 L39.5755014,38.7626812 Z M63.1342162,30.0182968 L60.1477736,37.6804912 L66.1211959,37.6804912 L63.1342162,30.0182968 Z M87.0458108,28.5267929 L83.5846959,28.5267929 L83.5846959,35.6464433 L87.0458108,35.6464433 C88.3127973,35.6464433 89.3251689,35.3076083 90.0832838,34.6294373 C90.8413986,33.9512663 91.2206351,33.0476704 91.2206351,31.9172185 C91.2206351,30.8774947 90.8413986,30.0520694 90.0832838,29.4419803 C89.3251689,28.8318554 88.3127973,28.5267929 87.0458108,28.5267929 L87.0458108,28.5267929 Z" id="Combined-Shape"></path></g></g></svg>
          </a>
					<div class="fxt-header">
						<p>Qapin Connects Clients, Inspection Engineers, And Inspection Companies That Provide Inspection Services</p>
					</div>
				</b-col>
				<b-col xl="8" lg="8" md="12" class="bg-white pos-rel"> 
          <div class="mobile-logo-wrap">
            <a href="javascript:void(0);" class="fxt-logo mt-1 d-block py-2 text-center">
              <svg class="m-auto" width="106px" height="24px" viewBox="0 0 106 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>0DDEA7CC-09FA-43D7-91E5-0FB6CE4E5E4E</title><g id="calendar-9Dec2020" stroke="none" stroke-width="1" fill="#000" fill-rule="evenodd"><g id="Header/header" transform="translate(-25.000000, -23.000000)" fill="#FFFFFF"><path d="M37.2171088,23 C40.6784385,23 43.5744946,24.1647612 45.9047399,26.4922442 C48.1732115,28.7147603 49.3481642,31.4316658 49.4297823,34.6412076 C49.4346831,34.8394428 49.2718155,35.0020449 49.0733162,35.0020449 L49.0733162,35.0020449 L43.9787986,35.0020449 C43.7939074,35.0020449 43.6317561,34.8510342 43.6242,34.6665013 C43.5543331,32.9586238 42.9458358,31.4993541 41.7983858,30.2895509 C40.5769865,28.9791096 39.049727,28.323084 37.2171088,28.323084 C35.3844905,28.323084 33.8572311,28.9791096 32.6358318,30.2895509 C31.4138953,31.5778468 30.8032135,33.149024 30.8032135,35.0020449 C30.8032135,36.8560677 31.4138953,38.4382996 32.6358318,39.7488125 C33.7821358,40.9579001 35.1978804,41.5998658 36.8825642,41.6742084 C37.0665959,41.6822938 37.2171088,41.8443236 37.2171088,42.0282841 L37.2171088,42.0282841 L37.2171088,46.643825 C37.2171088,46.8419528 37.0543845,47.0045192 36.8561,47 C33.5312811,46.9226278 30.7444838,45.7713542 28.4951351,43.5461191 C26.1648899,41.2181352 25,38.3702536 25,35.0020449 C25,31.6348381 26.1648899,28.7975819 28.4951351,26.4922442 C30.8254162,24.1647612 33.7325736,23 37.2171088,23 Z M65.6810811,23.3393359 C65.8110743,23.3393359 65.9582568,23.4371834 66.00875,23.5567828 L66.00875,23.5567828 L75.4832162,46.0364191 C75.5974527,46.3076731 75.4499122,46.5296278 75.1551892,46.5296278 L75.1551892,46.5296278 L69.82475,46.5296278 C69.6915338,46.5296278 69.5425608,46.4282385 69.4938581,46.304346 L69.4938581,46.304346 L68.0213176,42.5628857 L58.2475088,42.5628857 L56.80795,46.3018416 C56.7597128,46.4271294 56.6103459,46.5296278 56.4760196,46.5296278 L56.4760196,46.5296278 L51.1480514,46.5296278 C50.8530777,46.5296278 50.7056446,46.30753 50.8204541,46.0360255 L50.8204541,46.0360255 L60.3275081,23.5563535 C60.3780014,23.4370046 60.5254345,23.3393359 60.6551412,23.3393359 L60.6551412,23.3393359 Z M87.1478716,23.474963 C90.1796149,23.474963 92.5549459,24.2323064 94.2749392,25.7465281 C96.0393378,27.2612148 96.9217162,29.3179089 96.9217162,31.9172185 C96.9217162,34.6072561 96.0056757,36.7431584 94.1732365,38.3248895 C92.3404392,39.8844395 89.8512297,40.663964 86.7066824,40.663964 L86.7066824,40.663964 L83.5846959,40.663964 L83.5846959,46.1743 C83.5846959,46.3697446 83.4246216,46.5296278 83.2290946,46.5296278 L83.2290946,46.5296278 L78.2048378,46.5296278 C78.0089527,46.5296278 77.8492365,46.3697446 77.8492365,46.1743 L77.8492365,46.1743 L77.8492365,23.8302908 C77.8492365,23.6348819 78.0089527,23.474963 78.2048378,23.474963 L78.2048378,23.474963 Z M105.023196,23.474963 C105.218723,23.474963 105.378797,23.6348819 105.378797,23.8302908 L105.378797,23.8302908 L105.378797,46.1743 C105.378797,46.3697446 105.218723,46.5296278 105.023196,46.5296278 L105.023196,46.5296278 L99.9989392,46.5296278 C99.8030541,46.5296278 99.6433378,46.3697446 99.6433378,46.1743 L99.6433378,46.1743 L99.6433378,23.8302908 C99.6433378,23.6348819 99.8030541,23.474963 99.9989392,23.474963 L99.9989392,23.474963 Z M114.003473,23.474963 C114.093716,23.474963 114.215115,23.5308452 114.273845,23.5991774 L114.273845,23.5991774 L125.298561,36.4602413 L125.298561,23.8302908 C125.298561,23.6348819 125.458635,23.474963 125.65452,23.474963 L125.65452,23.474963 L130.644399,23.474963 C130.839926,23.474963 131,23.6348819 131,23.8302908 L131,23.8302908 L131,46.1743 C131,46.3697446 130.839926,46.5296278 130.644399,46.5296278 L130.644399,46.5296278 L126.749973,46.5296278 C126.660804,46.5296278 126.54048,46.4749262 126.482108,46.4081323 L126.482108,46.4081323 L115.525074,33.8831845 L115.525074,46.1743 C115.525074,46.3697446 115.365,46.5296278 115.169473,46.5296278 L115.169473,46.5296278 L110.144858,46.5296278 C109.949331,46.5296278 109.789257,46.3697446 109.789257,46.1743 L109.789257,46.1743 L109.789257,23.8302908 C109.789257,23.6348819 109.949331,23.474963 110.144858,23.474963 L110.144858,23.474963 Z M40.9961878,37.3183301 C41.0893676,37.2235593 41.2658074,37.1883557 41.3882804,37.2400521 L41.3882804,37.2400521 L47.9629304,40.0156303 C48.1582784,40.0980941 48.2363101,40.3184031 48.1404804,40.5073722 C47.5850905,41.6023701 46.8356419,42.6135446 45.8997622,43.5484804 C44.9502385,44.4876735 43.8896297,45.2389349 42.7488764,45.7945013 C42.5615142,45.8857303 42.3433547,45.8075596 42.2616345,45.615943 L42.2616345,45.615943 L39.5021966,39.1514596 C39.4506291,39.0310374 39.4836108,38.8560925 39.5755014,38.7626812 L39.5755014,38.7626812 Z M63.1342162,30.0182968 L60.1477736,37.6804912 L66.1211959,37.6804912 L63.1342162,30.0182968 Z M87.0458108,28.5267929 L83.5846959,28.5267929 L83.5846959,35.6464433 L87.0458108,35.6464433 C88.3127973,35.6464433 89.3251689,35.3076083 90.0832838,34.6294373 C90.8413986,33.9512663 91.2206351,33.0476704 91.2206351,31.9172185 C91.2206351,30.8774947 90.8413986,30.0520694 90.0832838,29.4419803 C89.3251689,28.8318554 88.3127973,28.5267929 87.0458108,28.5267929 L87.0458108,28.5267929 Z" id="Combined-Shape"></path></g></g></svg>
            </a>
          </div>
          <div class="header-menu mt-4">
            <div class="d-flex align-items-center">
              <!--<label class="mr-2">Already have an account?</label>-->
              <router-link
                  to="/login"
                  type="submit"
                  v-if="$route.path === '/forgot-password'"
                  class="btn btn-outline-theme"
                >
                  Back
                </router-link>
            </div>
          </div>
          <div class="fxt-bg-color">
            <div class="fxt-content">
              <div class="fxt-form">
                <h2 class="title mb-0">Set a new password!</h2>
                <h5 class="subtitle mb-4">Enter a new password for this account.</h5>
                <form action="" @submit.prevent="submitResetData">
                  <div class="form-group pos-rel mb-2">
                    <label>New Password</label>
                    <!-- <v-text-field
                      type="password"
                      v-model="password"
                      placeholder="Enter New Password"
                      :error-messages="passwordErrors"
                      @input="$v.password.$touch()"
                      @blur="$v.password.$touch()"
                    /> -->
                    <v-text-field
                      type="password"
                      v-model="password"
                      placeholder="Enter New Password"
                      autocomplete="new-password"
                      :error-messages="passwordErrors"
                      @input="$v.password.$touch()"
                      @blur="$v.password.$touch()"
                      :minlength="6"
                      :maxlength="16"
                    />
                  </div>
                  <div class="form-group pos-rel mb-2">
                    <label>Confirm Password</label>
                    <!-- <v-text-field
                      type="password"
                      v-model="confirmpassword"
                      placeholder="Enter Confirm Password"
                      :error-messages="confirmpasswordErrors"
                      @input="$v.confirmpassword.$touch()"
                      @blur="$v.confirmpassword.$touch()"
                    /> -->
                    <v-text-field
                      type="password"
                      v-model="confirmpassword"
                      placeholder="Enter Confirm Password"
                      autocomplete="new-password"
                      :error-messages="confirmpasswordErrors"
                      @input="$v.confirmpassword.$touch()"
                      @blur="$v.confirmpassword.$touch()"
                      :minlength="6"
                      :maxlength="16"
                    />
                  </div>
                  <div class="form-group text-right">
                    <button
                      type="submit"
                      class="btn btn-theme mt-4"
                      v-if="!loadingBtn"
                    >
                      Submit
                    </button>
                    <button
                      disabled="true"
                      v-if="loadingBtn"
                      class="btn btn-theme mt-4"
                    >
                      Updating...
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
				</b-col>
			</b-row>
		</div>
	</section>
</template>
<script>
  import { validationMixin } from 'vuelidate'
  import { required,minLength,maxLength,sameAs } from 'vuelidate/lib/validators';
  import { mapActions } from "vuex";
  export default {
    title: 'Forget Password | Qapin',
    mixins: [validationMixin],
    validations() {
    return {
        password: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(16),
        },
        confirmpassword: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(16),
          sameAsPassword: sameAs(() => this.password),
        },
      };
    },
    components: {

    }, 
    data() {
      return {
        password: '',
        confirmpassword: '',
        token:'',
        loadingBtn : false,
      }
    }, 
    computed: {
      passwordErrors() {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push("Password is required");
        !this.$v.password.minLength && errors.push("Password must be minimum 6 characters"); 
        !this.$v.password.maxLength && errors.push("Password must be maximum 16 characters");
        return errors
      },
      confirmpasswordErrors() {
        const errors = []
        if (!this.$v.confirmpassword.$dirty) return errors
        !this.$v.confirmpassword.required && errors.push("Confirm Password is required");
        !this.$v.confirmpassword.minLength && errors.push("Confirm Password must be minimum 6 characters"); 
        !this.$v.confirmpassword.maxLength && errors.push("Confirm Password must be maximum 16 characters");
        !this.$v.confirmpassword.sameAsPassword && errors.push("Confirm passwords do not match");
        return errors
      },
    },
    async mounted() {
      this.checktoken();
    },
    methods: {
      ...mapActions(["genericAPIPOSTForNodeRequestResponse","genericAPIGETForNodeRequestResponse"]),
      async checktoken(){
        try {
          var response = await this.genericAPIGETForNodeRequestResponse({
            requestUrl:`checkresetLink/${this.$route.params.pid}`,
          });
          console.log('response',response)
          if(response.status === "true" ){
            this.token = this.$route.params.pid;
          }else{
            if(response.message === "This link is Expired") {
              this.$toastr.e(`${response.message}`);
            }else{
              this.$toastr.e('Invalid token');
            }
            this.state.currentUserData = '';
            localStorage.removeItem("token"); 
            localStorage.removeItem("accountType"); 
            localStorage.removeItem("loginUserData"); 
            // window.location.href = "/login";
            this.$router.push('/login').catch(()=>{});
          }
        } catch (error) {
          error
          // this.$toastr.e(error);
          localStorage.removeItem("token"); 
          localStorage.removeItem("accountType"); 
          localStorage.removeItem("loginUserData"); 
          // window.location.href = "/login";
          this.$router.push('/login').catch(()=>{});
        }
      },
      async submitResetData(){ 
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.loadingBtn = true;
          const data = {
            "token":`${this.token}`,
            "confpassword":`${this.password}`,
            "newpassword":`${this.confirmpassword}`
          }
          try {
            var response = await this.genericAPIPOSTForNodeRequestResponse({
              requestUrl: "resetPassword",
              params: data,
            });
            if (response.status === "true") { 
              this.$toastr.s(response.message);
              this.$router.push('/login').catch(()=>{});
            }else{
              this.loadingBtn = false;
              this.$toastr.e(response.message);
            }
          } catch (error) {
            error
            this.loadingBtn = false;
            this.$toastr.e('Something went wrong please try again!')
          }
        }
      }
    }  

  }
</script>

<style>
  navbar-main{display:none!important;}
  /* .relative{padding:0px!important} */
  .fxt-bg-img2{
    background-image: url('../assets/img/forget-bg.png')!important;
  }
  .fxt-bg-img{
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;
    position: relative;
  }
  .login-wrapper .fxt-bg-color {
    background-color: #ffffff;
    min-height: 100vh;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    /*padding: 60px 30px;*/
  padding:100px 7px;
}
.login-wrapper .fxt-content {
    max-width: 550px;
    width: 100%;
}
.login-wrapper .title{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 45px;
  color: #000000;
}
.login-wrapper .subtitle{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  color: #979797;
}
.login-wrapper label{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
}
.login-wrapper input{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  background: #FFFFFF;
  border: 1px solid #CECECE;
  border-radius: 6px;
}
.login-wrapper .btn{
  padding:6px 45px!important;
}
.login-wrapper .btn:hover{
  padding:6px 45px!important;
}
.login-wrapper .fxt-header{
  position:absolute;
  bottom:20px;
  left: 20%;
  right: 20%;
}
.login-wrapper .fxt-header p{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF !important;
}
.theme--light.v-text-field>.v-input__control>.v-input__slot:before{border:0px;}
.v-text-field{margin-top:0px!important;padding-top:5px!important;}
.v-input input{padding: 6px 12px!important;max-height:43px!important;}
.v-text-field__details{position: absolute;bottom: -8px;right: 0;}
.header-menu{position:absolute;right:20px;}
.v-text-field>.v-input__control>.v-input__slot:after{border-color: transparent!important;border-style: none!important;}
.mobile-logo-wrap{display:none;}
@media only screen and (min-width: 320px) and (max-width: 815px) {
  .fxt-bg-img{display:none;}
  .mobile-logo-wrap{display:block;background-color:#F2613C;}
}
p {margin-top: 0!important;margin-bottom: 1rem!important;}
h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {margin-top: 0!important;margin-bottom: 0.5rem!important;font-weight: 500!important;line-height: 1.2!important;}
</style>


